import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AttributeValue, EditedAttributeValues, FormTypes } from '../../../models/section-definition.model';
import { slideToggle } from '../../../helpers/slidetoggle';
import { StaticDropdownOption } from '../static-field-rows/static-dropdown-edit-row/static-dropdown-edit-row.component';

@Component({
  selector: 'lib-equipment-section',
  standalone: false,
  templateUrl: './equipment-section.component.html',
  styleUrl: './equipment-section.component.scss',
  animations: [slideToggle],
})
export class EquipmentSectionComponent implements OnInit, OnChanges {
  @Input() equipmentInstances: Record<string, any[]> = {};
  @Input() editEnabled: boolean = false;
  @Input() editableAttributeIds: number[] = [];
  @Input() editedValuesByAsset: Record<string, EditedAttributeValues> = {};
  @Input() isAssetRatingEditable: boolean = false;
  @Input() assetRatingOptions: StaticDropdownOption<number>[] = [];
  @Input() editedAssetRatings: Record<string, number | null> = {};

  devicesCardExpanded: boolean = true;
  // current index for each group
  currentIndexes: Record<string, number> = {};


  ngOnInit() {
    Object.keys(this.equipmentInstances).forEach(key => {
      this.currentIndexes[key] = 0; // start with first item per group
    });
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['equipmentInstances'] && this.equipmentInstances) {
    // Initialize indexes for all groups
    Object.keys(this.equipmentInstances).forEach(key => {
      if (this.currentIndexes[key] === undefined) {
        this.currentIndexes[key] = 0;
      }
    });
  }
}

  // taken from SectionInstanceCardComponent
  @Output() mapClicked = new EventEmitter<AttributeValue>();
  FormTypes = FormTypes;
  onMapClick(attributeValue: AttributeValue) {
    this.mapClicked.emit(attributeValue);
  }

  getAttributeTypeString(type: number): string {
    return FormTypes[type];
  }

  getRowType(
    attr: AttributeValue
  ):
    | 'number-edit'
    | 'text-edit'
    | 'date-edit'
    | 'image-edit'
    | 'dropdown-edit'
    | 'selected-options'
    | 'location'
    | 'image'
    | 'file'
    | 'default' {
    if (this.editEnabled && this.editableAttributeIds.includes(attr.attributeDefinitionId)) {
      if (attr.type === this.getAttributeTypeString(FormTypes.Number)) return 'number-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.Text)) return 'text-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.DateTime)) return 'date-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.Image)) return 'image-edit';
      if (attr.type === this.getAttributeTypeString(FormTypes.Dropdown)) return 'dropdown-edit';
    }
    if (
      attr.type === this.getAttributeTypeString(FormTypes.MultiSelect) ||
      attr.type === this.getAttributeTypeString(FormTypes.SingleSelect)||
      attr.type === this.getAttributeTypeString(FormTypes.Dropdown) ||
      attr.type === this.getAttributeTypeString(FormTypes.ConditionalDropdown) ||
      attr.type === this.getAttributeTypeString(FormTypes.ChildDropdown)
    )
      return 'selected-options';
    if (attr.type === this.getAttributeTypeString(FormTypes.Location))
      return 'location';
    if (attr.type === this.getAttributeTypeString(FormTypes.Image))
      return 'image';
    if (attr.type === this.getAttributeTypeString(FormTypes.File))
      return 'file';

    return 'default';
  }

  getEditedValues(mrId: string): EditedAttributeValues {
    return (this.editedValuesByAsset[mrId] ??= {});
  }

  prev(groupKey: string) {
    if (this.currentIndexes[groupKey] > 0) {
      this.currentIndexes[groupKey]--;
    }
  }

  next(groupKey: string, groupValue: any[]) {
    if (this.currentIndexes[groupKey] < groupValue.length - 1) {
      this.currentIndexes[groupKey]++;
    }
  }

  formatKey(key: string): string {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  hasAttributeValues(item: any): boolean {
    return !!item?.assetRating || (item?.sectionInstances?.some((s: any) => s.attributeValues?.length > 0) ?? false);
  }
}
